module.exports = __webpack_public_path__ + "static/media/Pin-Dropoff.ccacc4dc.svg";